import React from 'react';
import PropTypes from 'prop-types';
import { Drawer, AdditionalNavItem } from '@sitebase/web-shell-kit';
import { MEDIA_RENDERER_TYPE } from '../../rendererTypes';
import { Radio } from '../RadioRenderer/Radio';
import withRadio from './../withRadio';

export const MediaMenu = (props) => {
  const { id, label, children, playing, playingLabel, marqueeText, animationOn, muted, onMuteToggle } = props;

  const additionalNavItemLabel = playing ? (
    <Radio
      label={marqueeText}
      playingLabel={playingLabel}
      animationOn={animationOn}
      onEqualizerClick={onMuteToggle}
      muted={muted}
    />
  ) : (
    label
  );

  return (
    <AdditionalNavItem id={id} label={additionalNavItemLabel} data-test-id={`${MEDIA_RENDERER_TYPE}_${id}`}>
      <Drawer data-test-id={`${MEDIA_RENDERER_TYPE}.dropdown_${id}`}>{children}</Drawer>
    </AdditionalNavItem>
  );
};

const dataPropTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string.isRequired,
  children: PropTypes.arrayOf(PropTypes.shape(React.children)),
  playing: PropTypes.bool,
  playingLabel: PropTypes.string,
  marqueeText: PropTypes.string,
  animationOn: PropTypes.bool,
  muted: PropTypes.bool,
  onMuteToggle: PropTypes.func,
};
MediaMenu.propTypes = dataPropTypes;

const renderFunction = ({ data, children }, runRenderer) => {
  const Menu = withRadio(MediaMenu, {
    forwardedKey: data.id,
    ...data,
    children: children.map((child) => runRenderer(child)),
  });
  return <Menu key={data.id} />;
};

renderFunction.propTypes = {
  data: PropTypes.shape(dataPropTypes),
  children: PropTypes.node,
};

const buildMediaMenuRenderer = () => ({
  type: MEDIA_RENDERER_TYPE,
  render: renderFunction,
  schema: {},
});

const MediaMenuRenderer = buildMediaMenuRenderer();

export default MediaMenuRenderer;
